import {
  diagram as originalDiagram,
  related,
  sourceIds,
} from './puzzles__art-gallery-evacuation-zone.mdx';

export { sourceIds, related };

export const diagram = {
  ...originalDiagram,
  src: '/diagrams/zh/art-gallery-pillars.svg',
  sourceId: 'art-gallery-pillars',
  caption: '原创示意图：前左灯柱选中间；后左选左侧；后右选左侧；前右选中间。',
  alt: '前左灯柱选中间；后左选左侧；后右选左侧；前右选中间。',
};
export const quickAnswer =
  '前左灯柱选中间；后左选左侧；后右选左侧；前右选中间。';

## 美术馆在哪里

进入 Evacuation Zone 的美术馆。以入口为参照区分前后，再设置四根灯柱。

## 正确灯光位置

- 前左：中间灯。
- 后左：左侧灯。
- 后右：左侧灯。
- 前右：中间灯。

## 完成后看哪里

左侧角落的门打开后，进入藏身处收集生命升级物品。

## 灯柱都操作过却没开门

操作过并不等于状态正确。重新站在入口核对方向，逐根检查选中的灯。别把“左侧灯”与“左边的柱子”混为一谈。
